import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import ProductCard from '@zenbusiness/dashboard-components/ProductCard';
import { PropTypes } from 'prop-types';
import { generatePath } from 'react-router-dom';

import { ROUTES } from '#client/manifest';
import {
  LD_RELEASE_TRY_BEFORE_YOU_BUY,
  MARKETING_TOOLS_MODAL_PARAM_KEY,
  PRODUCT_CARD_STATUS,
  websiteEditorModalParam
} from '#client/pages/MarketingTools/utils/constants';
import { dataTrackingPropsType } from '#client/utils/reporting';
import { buildCartUrl } from '#client/utils/urls';

const PRODUCT = 'static_website';

const WebsiteProductCard = ({
  isPurchased = false,
  hasActiveWebsites = false,
  onLearnMoreClick,
  dataTrackingProps
}) => {
  const { businessEntityUuid } = useBusinessEntity();
  const releaseTryBeforeYouBuy = useExperimentFlag(LD_RELEASE_TRY_BEFORE_YOU_BUY, false);

  const getPrimaryButtonProps = (() => {
    if (isPurchased || hasActiveWebsites) {
      return {
        label: 'Go to it',
        url: generatePath(ROUTES.websiteList, {
          businessEntityUuid
        }),
        target: '_self'
      };
    }
    if (releaseTryBeforeYouBuy) {
      return {
        label: 'Try free',
        url: generatePath(`${ROUTES.websiteList}?${MARKETING_TOOLS_MODAL_PARAM_KEY}=${websiteEditorModalParam}`, {
          businessEntityUuid
        }), // TODO: FIND A BETTER WAY TO MIMIC "appendUrl" LOGIC
        target: '_self'
      };
    }
    return {
      label: 'Buy now',
      url: buildCartUrl(PRODUCT, { businessEntityUuid }),
      target: '_self'
    };
  })();

  return (
    <ProductCard
      description="Simple web editor that makes building a custom website easy."
      eventProps={dataTrackingProps}
      imageUrl="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/vector/business-website.svg"
      status={isPurchased ? PRODUCT_CARD_STATUS.PURCHASED : null}
      primaryCta={{
        label: 'Learn more',
        modalName: PRODUCT
      }}
      secondaryCta={getPrimaryButtonProps}
      title="Website Builder"
      onCtaClick={onLearnMoreClick}
    />
  );
};

WebsiteProductCard.propTypes = {
  isPurchased: PropTypes.bool.isRequired,
  hasActiveWebsites: PropTypes.bool.isRequired,
  onLearnMoreClick: PropTypes.func.isRequired,
  dataTrackingProps: dataTrackingPropsType
};

export default WebsiteProductCard;
